import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/responsive-global.css";
import { applyOsDisplayScaleToRoot } from "./utils/osDisplayScale";

applyOsDisplayScaleToRoot();
window.addEventListener("resize", applyOsDisplayScaleToRoot);
if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", applyOsDisplayScaleToRoot);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
requestAnimationFrame(() => applyOsDisplayScaleToRoot());

reportWebVitals();
